import "./quem-somos.css";

export default function QuemSomos() {
  return (
    <section className="quem-somos">
      <div className="qs-container">

        <header className="qs-header">
          <h1>Quem Somos</h1>
          <p>
            Comunicação, projetos sociais e boas notícias do Maranhão
          </p>
        </header>

        <article className="qs-text">
          <p>
            <strong>O Rufado</strong> é um portal de comunicação independente
            dedicado à divulgação de boas notícias, projetos sociais, ações
            comunitárias e iniciativas de impacto social, com foco no Maranhão
            e, quando necessário, em outras regiões do Brasil.
          </p>

          <p>
            O nome <strong>O Rufado</strong> faz referência ao som do tambor,
            símbolo ancestral de anúncio, chamado e identidade cultural.
            Assim como o rufar do tambor anuncia algo importante, O Rufado
            nasce para dar visibilidade ao que precisa ser visto, ouvido
            e valorizado.
          </p>

          <p>
            O projeto surge como um empreendimento de comunicação idealizado
            por três mulheres — uma artista visual, uma fotógrafa e uma
            jornalista — unidas pelo desejo de comunicar com propósito e
            fortalecer iniciativas que transformam realidades.
          </p>

          <p>
            Em <strong>O Rufado</strong>, você encontra conteúdos dedicados à
            divulgação de:
          </p>

          <ul>
            <li>ONGs e organizações sociais</li>
            <li>associações e coletivos</li>
            <li>ações comunitárias</li>
            <li>projetos sociais e culturais</li>
            <li>
              iniciativas que promovem cidadania e desenvolvimento social
            </li>
          </ul>

          <p>
            As histórias publicadas no portal são reais, produzidas com
            responsabilidade jornalística, sensibilidade humana e compromisso
            com o impacto positivo no Maranhão.
          </p>
        </article>

        <section className="qs-block">
          <h2>Parcerias e Comunicação Institucional</h2>
          <p>
            O Rufado também é um espaço aberto para parcerias com órgãos
            públicos, entidades, coletivos e empresas socialmente responsáveis,
            contribuindo para a divulgação de serviços, ações, projetos e
            iniciativas de interesse público.
          </p>
          <p>
            Todas as parcerias seguem princípios de ética, transparência e
            alinhamento de valores.
          </p>
        </section>

        <section className="qs-values">
          <span>Compromisso social</span>
          <span>Comunicação acessível</span>
          <span>Cultura e identidade</span>
          <span>Ética e transparência</span>
          <span>Protagonismo feminino</span>
          <span>Esperança</span>
        </section>

      </div>
    </section>
  );
}
